export default "__VITE_ASSET__BE18tGz2__"